module.exports = __webpack_public_path__ + "static/media/ruler.51390d0f.svg";